import { render, staticRenderFns } from "./HtmlTable.vue?vue&type=template&id=03565e4c&scoped=true"
import script from "./HtmlTable.vue?vue&type=script&lang=ts"
export * from "./HtmlTable.vue?vue&type=script&lang=ts"
import style0 from "./HtmlTable.vue?vue&type=style&index=0&id=03565e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03565e4c",
  null
  
)

export default component.exports